import React from "react";

import { IconButton, Tooltip, Menu, MenuItem, Typography } from "../helper";
import More from "../../../../assests/icons/More";

export default function ChallanMenu({
  settings,
  handleOpenUserMenu,
  anchorElUser,
  handleCloseUserMenu,
}) {
  return (
    <React.Fragment>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 1, ml: 1 }}>
          <More />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting.label} onClick={handleCloseUserMenu}>
            <Typography
              sx={{ color: "rgba(226, 19, 110, 1)" }}
              textAlign="center"
              onClick={setting.action}
            >
              {setting.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}
